import Belinda from './img/Belinda.png';

const BusinessAnalyst = {
  image: Belinda,
  name: 'Belinda Wang',
  position: 'Business Analyst',
  bulletPoint1: 'Analyse and document business requirements and process',
  bulletPoint2: 'Facilitate and collaborate with agile teams to drive solutions',
  bulletPoint3: 'Manage sprint planning and project delivery',
  LinkedinURL: 'www.linkedin.com/in/wangbelinda'
};
export default BusinessAnalyst;
